import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from 'components/widgets/Container';
import SettingsStyles from 'styles/modules/settings/SettingsStyles';
import {
    List, ListItem, ListItemIcon, ListItemText,
} from '@material-ui/core';
import { useHistory, useParams } from 'react-router-dom';
import { modules } from 'utils/enum/modules';
import RoleBuilder from 'components/widgets/settings/RoleBuilder';
import CustomFieldsSettings from 'components/widgets/customfields/CustomFieldsSettings';
import CompanySettingCategory, { CompanySettingkey } from 'utils/enum/CompanySettingEnum';

// utils
import KeyStore from 'utils/KeyStore';
import Permission from 'utils/enum/Permissions';
import ServiceDefaultSettings from 'components/modules/settings/service/ServiceDefaultSettings';
import { TuneOutlinedIcon } from 'components/icons';

// icons
import InputOutlinedIcon from '@material-ui/icons/InputOutlined';

const useStyles = makeStyles((theme) => SettingsStyles.settingsPanelItem(theme));
const subTabs = ['default', 'custom-fields', 'technician'];
const getSelectedTab = (subtab) => {
    const tabIndex = subTabs.indexOf(subtab);
    if (tabIndex !== -1) return tabIndex;

    return 0;
};

const getSettings = () => {
    const keyStore = new KeyStore();
    const settings = [];

    if (keyStore.hasPermission(Permission.SERVICE_SETTINGS_READ)) {
        settings.push(
            {
                index: 0,
                text: 'Default Settings',
                icon: <TuneOutlinedIcon />,
                component: <ServiceDefaultSettings />,
            },
            {
                index: 1,
                text: 'Custom Fields',
                icon: <InputOutlinedIcon />,
                component: <CustomFieldsSettings
                    module={modules.SERVICE}
                    writable={keyStore.hasPermission(Permission.SERVICE_SETTINGS_WRITE)}
                />,
            },
            {
                index: 2,
                text: 'Technician',
                icon: <TuneOutlinedIcon />,
                component: <RoleBuilder
                    canWrite={keyStore.hasPermission(Permission.SERVICE_SETTINGS_WRITE)}
                    category={CompanySettingCategory.SERVICE}
                    property={CompanySettingkey.TECHNICIAN_GLOBAL_ROLE}
                />,
            },
        );
    }

    return settings;
};

const ServiceSettings = () => {
    const classes = useStyles();
    const history = useHistory();
    const { maintab, subtab } = useParams();

    const [activeIndex, setActiveIndex] = useState(getSelectedTab(subtab || 0));

    const handleChange = (newIndex) => {
        history.push(`/settings/${maintab}/${subTabs[newIndex]}`);
        setActiveIndex(newIndex);
    };

    const settingsItems = getSettings();

    return (
        <>
            <Container className={classes.rootContainer}>
                <List component="nav" className={classes.sideBar}>
                    {settingsItems.map((item) => (
                        <ListItem key={item.index} onClick={() => handleChange(item.index)} button selected={activeIndex === item.index}>
                            <ListItemIcon>
                                {item.icon}
                            </ListItemIcon>
                            <ListItemText primary={item.text} />
                        </ListItem>
                    ))}
                </List>
                <div className={classes.content}>
                    {settingsItems.map((item) => (
                        activeIndex === item.index && <div key={item.index}>{item.component}</div>
                    ))}
                </div>
            </Container>
        </>
    );
};

export default ServiceSettings;
